var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-table',{attrs:{"fields":_vm.fields,"items":_vm.data.form.atestados,"sort-by":"data","tag":"div"},scopedSlots:_vm._u([{key:"cell(data)",fn:function(row){return [_vm._v(" "+_vm._s(_vm._f("formatDate")(row.value))+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }